import { environment } from '../config/environment';
import { getMethod, putMethod } from './_helper';

const selfUrl = environment.apilUrl;

export const staffServ = {
  getStaffDetail,
  updateStaff,
  getUsers
};

async function getStaffDetail(params) {
  return getMethod(`${selfUrl}/staff/detail`, params)
}

async function updateStaff(params) {
  return putMethod(`${selfUrl}/staff`, params)
}

async function getUsers(params = {}) {
  return getMethod(`${selfUrl}/staff/colleague?userId=${params.id}`, )
}